import Vue from 'vue'

import config from '../config'

//注册全局方法
Vue.prototype.$config = config;